import React from 'react'
import { Container } from 'react-bootstrap'
import AuthNavbar from "../components/AuthNavbar/AuthNavbar"
import { useSelector } from 'react-redux';

function Teacherreserve() {
      const { currentLocal } = useSelector((state) => state.currentLocal);
    
  return (
    <div className="px-0 my-3 w-100 dashboard_content h-75">
    <Container className='h-100'>
        <div className="d-flex flex-column w-100 h-100">
            <AuthNavbar />
            <div className="mt-5 mx-3 d-flex justify-content-center align-items-center h-75">

          

        <p className='fw-bold fs-2'>{currentLocal.home.ComingSoon}</p>


            </div>

        </div>
    </Container>
</div>
  )
}

export default Teacherreserve